import { SimpleTabs } from './SimpleTabs'
import { TeamTabs } from './TeamTabs'
import { SwiperTabs } from './SwiperTabs'

SimpleTabs.Tab = SimpleTabs.Tab
SimpleTabs.Content = SimpleTabs.Content
SimpleTabs.displayName = 'SimpleTabs'

TeamTabs.Tab = TeamTabs.Tab
TeamTabs.Content = TeamTabs.Content
TeamTabs.displayName = 'TeamTabs'

SwiperTabs.Tab = SwiperTabs.Tab
SwiperTabs.Content = SwiperTabs.Content
SwiperTabs.displayName = 'TeamTabs'

export {
  SimpleTabs,
  TeamTabs,
  SwiperTabs
}